import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const emptyPitch = { name: "", surface: "grass", venue_id: "", capacity: 22, game_format: "", hourly_rate: 0, image_url: "", description: "", open_hour: 8, close_hour: 22, pitch_dimensions: "", no_games: false, training_season: "both" };

export function PitchForm({ value, onChange, venues }) {
  const upd = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const updN = (k) => (e) => onChange({ ...value, [k]: e.target.value === "" ? "" : parseInt(e.target.value) });
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="col-span-2">
        <Label className="text-xs uppercase tracking-widest opacity-70">Venue</Label>
        <Select value={value.venue_id || ""} onValueChange={(v)=>onChange({...value, venue_id: v})}>
          <SelectTrigger className="mt-2"><SelectValue placeholder="Select a venue" /></SelectTrigger>
          <SelectContent>{venues.filter(v => v.active).map(v => <SelectItem key={v.id} value={v.id}>{v.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="col-span-2"><Label className="text-xs uppercase tracking-widest opacity-70">Name</Label><Input value={value.name} onChange={upd("name")} className="mt-2" placeholder="Main Ground" /></div>
      <div>
        <Label className="text-xs uppercase tracking-widest opacity-70">Surface</Label>
        <Select value={value.surface} onValueChange={(v)=>onChange({...value, surface: v})}>
          <SelectTrigger className="mt-2"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="grass">Grass</SelectItem><SelectItem value="3g">3G All-Weather</SelectItem>
            <SelectItem value="astro">Astro</SelectItem><SelectItem value="indoor">Indoor</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div><Label className="text-xs uppercase tracking-widest opacity-70">Capacity</Label><Input type="number" min={1} value={value.capacity} onChange={updN("capacity")} className="mt-2" /></div>
      <div>
        <Label className="text-xs uppercase tracking-widest opacity-70">Pitch size</Label>
        <Select value={value.game_format || "none"} onValueChange={(v)=>onChange({...value, game_format: v === "none" ? "" : v})}>
          <SelectTrigger className="mt-2" data-testid="pitch-form-format-select"><SelectValue placeholder="Any" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Any / unspecified</SelectItem>
            <SelectItem value="3v3">3v3</SelectItem>
            <SelectItem value="5v5">5v5</SelectItem>
            <SelectItem value="7v7">7v7</SelectItem>
            <SelectItem value="9v9">9v9</SelectItem>
            <SelectItem value="11v11">11v11</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div><Label className="text-xs uppercase tracking-widest opacity-70">Opens (hour)</Label><Input type="number" min={0} max={23} value={value.open_hour} onChange={updN("open_hour")} className="mt-2" /></div>
      <div><Label className="text-xs uppercase tracking-widest opacity-70">Closes (hour)</Label><Input type="number" min={1} max={24} value={value.close_hour} onChange={updN("close_hour")} className="mt-2" /></div>
      <div className="col-span-2">
        <Label className="text-xs uppercase tracking-widest opacity-70">Pitch dimensions</Label>
        <Input value={value.pitch_dimensions || ""} onChange={upd("pitch_dimensions")} className="mt-2" placeholder="e.g. 60x40 yd or 82x50 m" data-testid="pitch-form-dimensions" />
        <div className="text-[10px] opacity-50 mt-1">Physical size of the playing area. Shown on the pitch card.</div>
      </div>
      <div className="col-span-2">
        <label className="flex items-start gap-3 rounded-md border border-border p-3 cursor-pointer hover:border-[#83B68B] transition-colors" data-testid="pitch-form-no-games-toggle">
          <input
            type="checkbox"
            checked={!!value.no_games}
            onChange={(e)=>onChange({...value, no_games: e.target.checked})}
            className="mt-0.5 accent-[#83B68B]"
          />
          <div>
            <div className="text-sm font-semibold">Training only (no games)</div>
            <div className="text-xs opacity-60 mt-0.5">Turn on for pitches where matches can't be played. The auto-scheduler will skip them and coaches can't book games here — training bookings still work.</div>
          </div>
        </label>
      </div>
      <div className="col-span-2">
        <Label className="text-xs uppercase tracking-widest opacity-70">Training season</Label>
        <Select value={value.training_season || "both"} onValueChange={(v)=>onChange({...value, training_season: v})}>
          <SelectTrigger className="mt-2" data-testid="pitch-form-training-season"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="both">Both — available year-round</SelectItem>
            <SelectItem value="winter">Winter training only</SelectItem>
            <SelectItem value="summer">Summer training only</SelectItem>
          </SelectContent>
        </Select>
        <div className="text-[10px] opacity-50 mt-1">Games ignore this — matches can be booked any season. Training bookings only see pitches for their season.</div>
      </div>
      <div className="col-span-2"><Label className="text-xs uppercase tracking-widest opacity-70">Image URL</Label><Input value={value.image_url || ""} onChange={upd("image_url")} className="mt-2" placeholder="https://…" /></div>
      <div className="col-span-2"><Label className="text-xs uppercase tracking-widest opacity-70">Description</Label><Textarea rows={2} value={value.description || ""} onChange={upd("description")} className="mt-2" /></div>
    </div>
  );
}
